"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyDecorator;
/**
 * @copyright 2016-present, Prometheus Research, LLC
 */

function applyDecorator(target, name, decorator) {
  var descriptor = Object.getOwnPropertyDescriptor(target, name);
  var nextDescriptor = decorator(target, name, descriptor) || descriptor;
  Object.defineProperty(target, name, nextDescriptor);
}
